/** Motion configuration for app-wide animations */
export const motionConfig = {
  /** Duration values in seconds (framer-motion uses seconds) */
  duration: {
    fast: 0.15,
    moderate: 0.25,
    normal: 0.3,
  },
  /** Easing presets */
  easing: {
    standard: "easeInOut",
    in: "easeIn",
    out: "easeOut",
  },
  /** Spring physics presets */
  spring: {
    stiff: { type: "spring", stiffness: 500, damping: 25 },
    gentle: { type: "spring", stiffness: 300, damping: 20 },
    bouncy: { type: "spring", stiffness: 400, damping: 10 },
  },
} as const;
